const planos = [
    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( acesso livre ) - recorrente",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"Em até 12x",
        parcela:"R$249,00",
        valorTotal:2988,
        source:"https://venda.nextfit.com.br/bd752d3c-d070-4706-af5f-b7c442c4fbed/contratos"
    },
    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/Semana ) - anual",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"Em até 12x",
        parcela:"R$199,00",
        valorTotal:2388,
        source:"https://venda.nextfit.com.br/55890114-1c44-4b37-af0f-cc8001dca4dd/contratos"
    },
    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 5x/Semana ) - trimestral",
        tx_adesão:"Grátis",
        duração:"3 meses",
        pagamento:"À vista",
        parcela:"R$1.047,00",
        valorTotal:1047,
        source:"https://venda.nextfit.com.br/02d89e65-e545-4b38-83dd-6e727cfbe107"
    }
]

export default planos;